import { HamburgerIcon } from "./hamburger-icon";

export default HamburgerIcon;
